import { Controller } from '@hotwired/stimulus'
import { jquery } from 'utils/jquery'

let placesLoaded

// Never rejects: rollbar.js captureUnhandledRejections would report every blocked Maps load.
function loadPlaces() {
  const src = window.ebGoogleMapsPlacesSrc
  if (!placesLoaded && src && !window.google?.maps?.places) {
    placesLoaded = new Promise((resolve) => {
      const url = new URL(src)
      url.searchParams.set('callback', 'ebGoogleMapsPlacesLoaded')
      window.ebGoogleMapsPlacesLoaded = resolve
      const script = document.createElement('script')
      script.src = url.toString()
      script.async = true
      script.onerror = resolve
      document.head.appendChild(script)
    })
  }
  return placesLoaded || Promise.resolve()
}

export default class extends Controller {
  static targets = [ 'input', 'output', 'disable' ]

  initialize() {
    // We have to manually add our 'with_errors' CSS state if organization location
    // is invalid on submission, as our text field and label are "dummy" fields.
    this.applyErrorState()
    // Maps blocked, or autocomplete_script not rendered here: the input stays plain text.
    loadPlaces().then(() => this.fetchLocation())
  }

  applyErrorState() {
    const $ = jquery();
    if (!$) {
      return;
    }

    var f = this.inputTarget;
    // Previous sibling can be the label, so check that too.
    if ($(f).hasClass('with_errors') || $(f).siblings().hasClass('with_errors')) {
      $(f).parent().children().addClass('with_errors');
    }
  }

  fallbackEnableSubmit() {
    // Microsoft Edge (some versions?) seem to blow up on the API call below,
    // and the submit button isn't re-enabled. So we force it to be after 2
    // seconds. We don't want to interfere with signups!
    this.disableTarget.disabled = false;
  }

  fetchLocation() {
    const places = window.google?.maps?.places
    if (!places?.Autocomplete) {
      return
    }

    const autocomplete = new places.Autocomplete(this.inputTarget, { types: ['(cities)'] })
    this.inputTarget.addEventListener('keydown', (event) => {
      if (event.keyCode === 13) {
        event.preventDefault()
      }
    })
    autocomplete.addListener('place_changed', () => {
      const place = autocomplete.getPlace()
      // Enter on text without picking a suggestion yields a place with only `name`.
      if (!place?.geometry) {
        return
      }

      this.disableTarget.disabled = true
      setTimeout(() => this.fallbackEnableSubmit(), 2000)
      const location = {
        address_components: place.address_components,
        formatted_address: place.formatted_address,
        lat: place.geometry.location.lat().toFixed(2),
        lng: place.geometry.location.lng().toFixed(2),
        utc_offset: place.utc_offset_minutes,
      }
      this.outputTarget.value = JSON.stringify(location)
      this.disableTarget.disabled = false
    })
  }
}
